import { range } from 'lodash'

export const makeCancelable = (promise) => {
  let hasCanceled_ = false;

  const wrappedPromise = new Promise((resolve, reject) => {
    promise.then(
      val => hasCanceled_ ? reject({isCanceled: true}) : resolve(val),
      error => hasCanceled_ ? reject({isCanceled: true}) : reject(error)
    );
  });

  return {
    promise: wrappedPromise,
    cancel() {
      hasCanceled_ = true;
    },
  };
};


export const thirdPillarMainTopic = 'ETIB03'

export const thirdPillarTopics = [

  'CUSTSERVIND',
  'CLEAREFF',
  'TABTIMEIMPDOC',
  'TABTIMEIMPBORD',
  'IMPTIMECOMPLIANCEIDX',
  'TABCOSTIMPDOC',
  'TABCOSTIMPBORD',
  'IMPCOSTCOMPLIANCEIDX',
  'TABTIMEEXPDOC',
  'TABTIMEEXPBORD',
  'EXPTIMECOMPLIANCEIDX',
  'TABCOSTEXPDOC',
  'TABCOSTEXPBORD',
  'EXPCOSTCOMPLIANCEIDX',
  'EOSQ147',
  'EOSQ395',
  'CUSTTRANSPIND'

]


export const countryFacilitationTopics = [
  'inf_availability',
  'inv_community',
  'adv_rulings',
  'appeal_proc',
  'fees_charges',
  'form_docs',
  'form_auto',
  'form_proc',
  'int_cooperation',
  'ext_cooperation',
  'gov_impartiality',
]


export const sevenPillarsMainTopic = 'ETI'
export const sevenPillarsTopics = [
  'ETIA01',
  'ETIA02',
  'ETIB03',
  'ETIC04',
  'ETIC05',
  'ETIC06',
  'ETID07',
]

export const allTFAArticles = range(1, 13).map(i => i.toString())


export const continentsColors = {
  'EU' : '#F9B233',
  'AS' : '#C629CE',
  'AF' : '#95C11F',
  'NA' : '#1DE5EF',
  'SA' : '#3990C4',
  'OC' : '#EEDF24',

}



// WEBPACK FOOTER //
// ./src/utils/index.js